import React from "react";

const Calzones = ({ menuData }) => {
  // Return null if no menuData is provided
  if (!menuData) return null;

  return (
    <div>
      <h2 className="flex font-rig text-brand-red text-4xl justify-center mb-4">
        Calzones
      </h2>
      <div>
        <ul>
          {menuData.map((el) => {
            return (
              <li className="mb-4" key={el.name}>
                <div className="font-typewriter font-bold flex justify-between">
                  <span>{el.name}</span>
                  <span>
                    <sup>$</sup>
                    {el.price}
                  </span>
                </div>
                <div className="font-typewriter-cond">
                  {el.description ? el.description : null}
                </div>
                <div className="text-brand-red ">
                  {el["add_on"]
                    ? el["add_on"].map((e) => {
                        return (
                          <div
                            key={e.name}
                            className="flex items-start justify-between font-typewriter font-medium"
                          >
                            <span className="flex-1">– {e.name}</span>
                            <span className="font-bold">
                              <sup>+ $</sup>
                              {e.price}
                            </span>
                          </div>
                        );
                      })
                    : null}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Calzones;
